e4.ecom.checkout = {
    debug: true,
    init: function () {
        if ( jQuery( '.js-e-checkout' ).length === 1 ) {
            e4.util.require.js( e4.settings.require.handlebars, function () {
                e4.ecom.checkout.handlebars.registerHelpers();
                e4.ecom.checkout.handlebars.registerPartials();
                e4.ecom.checkout.handlebars.compileTemplate();
                e4.ecom.checkout.bindEvents();
            } );

        }
        if ( jQuery( '.js-e-checkout-receipt' ).length === 1 ) {
            e4.ecom.checkout.steps.receipt.init();
        }
    },
    handlebars: {
        orderTmpl: null,
        cartTmpl: null,
        summeryTmpl: null,
        glsResultsTmpl: null,
        registerHelpers: function () {
            if ( window.Handlebars.helpers.compare === undefined ) {
                Handlebars.registerHelper( 'compare', function ( v1, operator, v2, options ) {
                    switch ( operator ) {
                    case '===':
                        return ( v1 === v2 ) ? options.fn( this ) : options.inverse( this );
                    case '!==':
                        return ( v1 !== v2 ) ? options.fn( this ) : options.inverse( this );
                    case '<':
                        return ( v1 < v2 ) ? options.fn( this ) : options.inverse( this );
                    case '<=':
                        return ( v1 <= v2 ) ? options.fn( this ) : options.inverse( this );
                    case '>':
                        return ( v1 > v2 ) ? options.fn( this ) : options.inverse( this );
                    case '>=':
                        return ( v1 >= v2 ) ? options.fn( this ) : options.inverse( this );
                    case '&&':
                        return ( v1 && v2 ) ? options.fn( this ) : options.inverse( this );
                    case '||':
                        return ( v1 || v2 ) ? options.fn( this ) : options.inverse( this );
                    default:
                        return options.inverse( this );
                    }
                } );
            }
            if ( window.Handlebars.helpers.counter === undefined ) {
                Handlebars.registerHelper( 'counter', function ( index ) {
                    return index + 1;
                } );
            }
        },
        registerPartials: function () {
            Handlebars.registerPartial( 'glsResults', jQuery( '#e-gls-handlebars-partial' ).html() );
            var glsResultsTmpl = jQuery( '#e-gls-handlebars-partial' ).html();
            e4.ecom.checkout.handlebars.glsResultsTmpl = Handlebars.compile( glsResultsTmpl );

        },
        compileTemplate: function () {
            var orderTmpl = jQuery( '#e-checkout-handlebars-template' ).html(),
                cartTmpl = jQuery( '#e-cart-handlebars-template' ).html(),
                summeryTmpl = jQuery( '#e-summery-handlebars-template' ).html();
            e4.ecom.checkout.handlebars.orderTmpl = Handlebars.compile( orderTmpl );
            e4.ecom.checkout.handlebars.cartTmpl = Handlebars.compile( cartTmpl );
            e4.ecom.checkout.handlebars.summeryTmpl = Handlebars.compile( summeryTmpl );
        }
    },
    bindEvents: function () {
        jQuery( window ).on( 'hashchange', function () {
            var hashStep = e4.util.hash.get( 'step' );
            if ( hashStep !== undefined ) {
                e4.ecom.checkout.order.get( hashStep, e4.settings.ecom.checkout.delay );
            }
        } );

        if ( e4.util.hash.get( 'step' ) === undefined ) {
            e4.util.hash.replace( 'step', e4.ecom.checkout.steps.first );
        }
        else {
            jQuery( window ).triggerHandler( 'hashchange' );
        }

        jQuery( '.js-e-checkout' ).on( 'hidden.bs.collapse', '.collapse', function () {
            if ( e4.ecom.checkout.steps.current !== e4.ecom.checkout.steps.target ) {
                if ( Math.max( jQuery( window ).width(), window.innerWidth ) > e4.settings.breakpoint[ e4.settings.ecom.checkout.multipageBreakpoint ] ) {
                    e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-step[data-step="' + e4.ecom.checkout.steps.target + '"]' ) );
                }
                else {
                    jQuery( window ).scrollTop( 0 );
                }
            }
            e4.ecom.checkout.steps.current = e4.ecom.checkout.steps.target;
        } ).on( 'shown.bs.collapse', '.collapse', function ( event ) {
            jQuery( event.currentTarget ).find( 'form' ).validate();
        } );

        e4.ecom.checkout.steps.init();
        e4.ecom.checkout.cart.init();
        e4.ecom.checkout.order.init();
    },
    cart: {
        init: function () {
            e4.ecom.checkout.cart.get();
            e4.ecom.checkout.cart.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-update-cart', function () {
                e4.ecom.checkout.cart.get();
            } );
        },
        get: function () {
            jQuery.ajax( {
                    url: e4.settings.ecom.cart.url,
                    type: 'POST',
                    beforeSend: function () {
                        jQuery( '.js-e-checkout-cart-loading-overlay' ).addClass( 'is-loading' );
                    },
                    data: jQuery( '.js-e-checkout-step-form' ).serialize()
                } )
                .done( function ( data ) {
                    e4.ecom.checkout.cart.build( data );
                    if ( e4.ecom.checkout.debug === true ) {
                        console.info( data );
                    }

                } )
                .fail( function ( error ) {
                    if ( e4.ecom.checkout.debug === true ) {
                        console.error( 'Failed to fetch CART DATA, please check your settings!.' );
                        console.error( error.responseText );
                    }
                } );
        },
        build: function ( data ) {
            setTimeout( function () {
                jQuery( '#js-e-checkout-cart' ).html( e4.ecom.checkout.handlebars.cartTmpl( data ) );
                jQuery( '#js-e-checkout-modal-cart' ).html( e4.ecom.checkout.handlebars.cartTmpl( data ) );
            }, e4.settings.ecom.checkout.delay );

        }
    },
    order: {
        hasChanged: {
            payment: false,
            shipping: false
        },
        init: function () {
            e4.ecom.checkout.order.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-update-order', function () {
                var jStep = jQuery( this ).closest( '.js-e-checkout-step' ).data( 'step' );

                if ( jStep !== e4.util.hash.get( 'step' ) ) {
                    e4.util.hash.set( 'step', jStep );
                }
                else {
                    jQuery( window ).triggerHandler( 'hashchange' );
                }

            } );
        },
        get: function ( step, delay ) {
            e4.ecom.checkout.steps.target = step;
            jQuery( '.js-e-checkout-step-previous' ).val( e4.ecom.checkout.steps.current );
            jQuery( '.js-e-checkout-step-current' ).val( e4.ecom.checkout.steps.target );
            jQuery( '.js-e-checkout-step-index' ).val( e4.ecom.checkout.steps.map[ e4.ecom.checkout.steps.target ] );

            jQuery.ajax( {
                    url: e4.settings.ecom.checkout.url,
                    type: 'POST',
                    beforeSend: function () {
                        jQuery( '.js-e-checkout-step-loading-overlay' ).addClass( 'is-loading' );
                    },
                    data: jQuery( '.js-e-checkout-step-form' ).serialize()
                } )
                .done( function ( data ) {
                    e4.ecom.checkout.order.dataHandler( data, e4.ecom.checkout.steps.target, delay );
                    if ( e4.ecom.checkout.debug === true ) {
                        console.info( data );
                    }

                } )
                .fail( function ( error ) {
                    if ( e4.ecom.checkout.debug === true ) {
                        console.error( 'Failed to fetch ORDER DATA, please check your settings!' );
                        console.error( error.responseText );
                    }

                } );
        },
        dataHandler: function ( data, step, delay ) {
            if ( data.steps.shipping.hasChanged === true ) {
                e4.ecom.checkout.order.hasChanged.shipping = data.steps.shipping.hasChanged;
                data.steps.shipping.hasChanged = 'e-checkout-step-has-changed';
            }
            if ( data.steps.payment.hasChanged === true ) {
                e4.ecom.checkout.order.hasChanged.payment = data.steps.payment.hasChanged;
                data.steps.payment.hasChanged = 'e-checkout-step-has-changed';
            }
            if ( data.steps.shipping.shippingmethodID === e4.settings.ecom.checkout.shipping.glsID ) {
                data.steps.shipping.isGLS = true;
            }
            e4.ecom.checkout.order.build( data, step, delay );
        },
        build: function ( data, step, delay ) {
            setTimeout( function () {
                jQuery( '#js-e-checkout-form' ).html( e4.ecom.checkout.handlebars.orderTmpl( data ) );
                jQuery( '#js-e-checkout-modal-summery' ).html( e4.ecom.checkout.handlebars.summeryTmpl( data ) );
                jQuery( '.js-e-checkout-loading-overlay' ).fadeOut( 'slow' );
                e4.ecom.checkout.steps.handler.switch();
                e4.ecom.checkout.tracking.step( data.steps[ e4.ecom.checkout.steps.current ] );
            }, delay );
        }

    },
    steps: {
        first: 'customer',
        current: 'customer',
        target: null,
        map: {
            customer: 1,
            payment: 2,
            shipping: 3,
            approve: 4
        },
        direction: null,
        init: function () {
            e4.ecom.checkout.steps.handler.init();
            e4.ecom.checkout.steps.customer.init();
            e4.ecom.checkout.steps.shipping.init();
            e4.ecom.checkout.steps.approve.init();

        },
        handler: {
            init: function () {
                e4.ecom.checkout.steps.handler.next();
                e4.ecom.checkout.steps.handler.edit();
            },
            switch: function () {
                e4.ecom.checkout.steps.handler.methodChange( e4.ecom.checkout.steps.current );

                var jCollapse = jQuery( '#js-e-checkout-accordion' );

                jCollapse.find( '.collapse.js-e-checkout-collapse-hide' ).collapse( 'hide' );
                jCollapse.find( '.collapse.js-e-checkout-collapse-show' ).collapse( 'show' );
                if ( e4.ecom.checkout.steps.map[ e4.ecom.checkout.steps.target ] === undefined ) {
                    e4.util.hash.replace( 'step', e4.ecom.checkout.steps.first );
                }
                else {
                    if ( e4.ecom.checkout.steps[ e4.ecom.checkout.steps.target ].show !== undefined ) {
                        e4.ecom.checkout.steps[ e4.ecom.checkout.steps.target ].show();
                    }
                }
                if ( e4.ecom.checkout.steps.target === 'approve' ) {
                    jQuery( '.js-e-checkout' ).css( '--summery-color', 'var(--summery-highlight-color)' );
                }
                else {
                    jQuery( '.js-e-checkout' ).css( '--summery-color', '' );
                }
            },
            next: function () {
                jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-change-step', function ( event ) {
                    event.preventDefault();
                    var jStep = jQuery( this ).data( 'target' ).replace( '#', '' ),
                        jForm = jQuery( this ).closest( 'form' );
                    if ( jForm.valid() === true ) {
                        e4.ecom.checkout.steps.direction = 'next';
                        e4.util.hash.set( 'step', jStep );
                    }
                } );
            },
            methodChange: function ( step ) {
                if ( step === 'payment' || step === 'shipping' ) {
                    jQuery( '.js-e-checkout-step[data-step="' + step + '"]' ).removeClass( 'e-checkout-step-has-changed' );
                    e4.ecom.checkout.order.hasChanged[ step ] = false;
                    //TODO - open and scroll to first step with issue if current step is valid
                }
            },
            edit: function () {
                jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-edit-step', function ( event ) {
                    event.preventDefault();
                    var jStep = jQuery( this ).data( 'target' ).replace( '#', '' );
                    e4.ecom.checkout.steps.target = jStep;
                    e4.ecom.checkout.steps.direction = 'previous';
                    e4.util.hash.set( 'step', jStep );
                } );
            }
        },
        customer: {
            init: function () {
                e4.ecom.checkout.steps.customer.alternativeAddress();
                e4.ecom.checkout.steps.customer.toggleFields();
            },
            toggleFields: function () {
                jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-toggle-field', function ( event ) {
                    event.preventDefault();
                    var jToggleField = jQuery( this ).val(),
                        jTarget = jQuery( '.js-e-checkout-toggle-target[data-target="' + jToggleField + '"]' );
                    jTarget.slideToggle( e4.settings.animation.speed );
                    if ( jQuery( this ).is( ':checked' ) === false ) {
                        jTarget.find( 'input' ).val( '' );
                    }
                } );
            },
            alternativeAddress: function () {
                jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-has-alternative-delivery-address', function () {
                    var jAlternativeShippingAddress = jQuery( '.js-e-checkout-alternative-delivery-address' );
                    if ( jQuery( this ).is( ':checked' ) === false ) {
                        jAlternativeShippingAddress.collapse( 'hide' ).find( 'input' ).val( '' );
                    }
                    else {
                        jAlternativeShippingAddress.collapse( 'show' );
                        e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-alternative-delivery-address' ) );
                    }
                } );
            }
        },
        payment: {},
        shipping: {
            init: function () {
                e4.ecom.checkout.steps.shipping.bindEvents();

            },
            show: function () {
                e4.ecom.checkout.steps.shipping.gls.init();
            },
            bindEvents: function () {
                jQuery( '.js-e-checkout' ).on( 'change', '.js-e-checkout-shipping-method', function () {
                    var jShippingID = jQuery( this ).val();
                    if ( jShippingID === e4.settings.ecom.checkout.shipping.pacsoftID ) {
                        e4.ecom.checkout.steps.shipping.pacsoft.show();
                        e4.ecom.checkout.steps.shipping.gls.hide();
                    }
                    else if ( jShippingID === e4.settings.ecom.checkout.shipping.glsID ) {
                        e4.ecom.checkout.steps.shipping.gls.show();
                        e4.ecom.checkout.steps.shipping.pacsoft.hide();
                    }
                    else {
                        e4.ecom.checkout.steps.shipping.pacsoft.hide();
                        e4.ecom.checkout.steps.shipping.gls.hide();
                    }
                } );
                jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-shippingmethod-gls-lookup-btn', function () {
                    jQuery( '.js-e-checkout-shippingmethod-gls-lookup' ).trigger( 'keyup' );
                } );
                jQuery( '.js-e-checkout' ).on( 'click', '.js-e-checkout-shippingmethod-gls-result-item', function () {
                    var jParcelShopID = jQuery( this ).val();
                    e4.ecom.checkout.steps.shipping.gls.set( jParcelShopID );
                } );
            },
            pacsoft: {
                init: function () {

                },
                show: function () {

                },
                hide: function () {

                }
            },
            gls: {

                init: function () {
                    e4.ecom.checkout.steps.shipping.gls.bindEvents();
                },
                show: function () {
                    jQuery( '.js-e-checkout-shippingmethod-gls' ).on( 'shown.bs.collapse', function () {
                        if ( jQuery( '.js-e-checkout-shippingmethod-gls-lookup' ).val() ) {
                            jQuery( '.js-e-checkout-shippingmethod-gls-lookup' ).trigger( 'keyup' );
                        }
                    } ).collapse( 'show' );
                },
                hide: function () {
                    jQuery( '.js-e-checkout-shippingmethod-gls' ).collapse( 'hide' );
                    e4.ecom.checkout.steps.shipping.gls.clear();
                },
                clear: function () {
                    jQuery( '.js-e-checkout-alternative-delivery-address' ).find( 'input' ).val( '' );
                    jQuery( '.js-e-checkout-shippingmethod-gls-id' ).val( '' );
                    e4.ecom.checkout.steps.shipping.gls.data = null;
                    jQuery( '#js-e-checkout-shippingmethod-gls-results' ).slideUp( e4.settings.animation.speed, function () {
                        jQuery( this ).html( '' );
                    } );

                },
                bindEvents: function () {
                    jQuery( '.js-e-checkout-shippingmethod-gls-lookup' ).on( 'keyup', function () {
                        var jSearchValue = jQuery( this ).val();
                        if ( jSearchValue.length > 3 ) {
                            e4.ecom.checkout.steps.shipping.gls.search( jQuery( this ).val() );
                        }
                        else {
                            e4.ecom.checkout.steps.shipping.gls.clear();
                        }
                    } );
                    jQuery( '.js-e-checkout-shippingmethod-gls-edit-btn' ).on( 'click', function ( event ) {
                        event.preventDefault();
                        e4.ecom.checkout.steps.shipping.gls.clear();
                        jQuery( window ).triggerHandler( 'hashchange' );

                    } );

                },
                set: function ( jParcelShopID ) {
                    var jAlternativeShippingAddress = jQuery( '.js-e-checkout-alternative-delivery-address' );
                    for ( var i = 0; i < e4.ecom.checkout.steps.shipping.gls.data.parcelshops.length; i++ ) {
                        e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].isSelected = '';
                        if ( e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].Number === jParcelShopID ) {
                            jAlternativeShippingAddress.find( 'input[name="EcomOrderDeliveryName"]' ).val( e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].CompanyName );
                            jAlternativeShippingAddress.find( 'input[name="EcomOrderDeliveryCompany"]' ).val( e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].Streetname2 );
                            jAlternativeShippingAddress.find( 'input[name="EcomOrderDeliveryAddress"]' ).val( e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].Streetname );
                            jAlternativeShippingAddress.find( 'input[name="EcomOrderDeliveryZip"]' ).val( e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].ZipCode );
                            jAlternativeShippingAddress.find( 'input[name="EcomOrderDeliveryCity"]' ).val( e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].CityName );
                            jQuery( '.js-e-checkout-shippingmethod-gls-id' ).val( e4.ecom.checkout.steps.shipping.gls.data.parcelshops[ i ].Number );
                        }

                    }
                },
                search: function ( jSearchValue ) {
                    jQuery.ajax( {
                            url: '/glslookup.ashx',
                            type: 'POST',
                            beforeSend: function () {
                                jQuery( '.js-e-checkout-step-loading-overlay' ).addClass( 'is-loading' );
                            },
                            data: {
                                count: 6,
                                type: 'ZIP',
                                zipcode: jSearchValue

                            }
                        } )
                        .done( function ( data ) {
                            e4.ecom.checkout.steps.shipping.gls.data = data;
                            jQuery( '.js-e-checkout-step-loading-overlay' ).removeClass( 'is-loading' );
                            e4.ecom.checkout.steps.shipping.gls.build();
                        } );

                },
                build: function () {
                    jQuery( '#js-e-checkout-shippingmethod-gls-results' ).html( e4.ecom.checkout.handlebars.glsResultsTmpl( e4.ecom.checkout.steps.shipping.gls.data ) ).slideDown( e4.settings.animation.speed, function () {
                        jQuery( this ).find( '.js-e-checkout-shippingmethod-gls-result-item' ).first().prop( 'checked', true ).triggerHandler( 'click' );
                        e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( '.js-e-checkout-shippingmethod-gls' ) );
                    } );

                }
            }

        },
        approve: {
            init: function () {
                e4.ecom.checkout.steps.approve.termsAndConditions.init();
            },
            newsletterSubscription: function () {
                jQuery( '.js-e-checkout' ).on( 'change', 'input[name="Co3EspressoEcomOrderSubscribeToNewsletter"]', function () {
                    jQuery( '.js-e-checkout-approve-form' ).find( 'input[name="EcomOrderSubscribeToNewsletter"]' ).val( this.checked === true ? 'true' : '' );
                } ).triggerHandler( 'change' );
            },
            termsAndConditions: {
                init: function () {
                    e4.ecom.checkout.steps.approve.termsAndConditions.get();
                    e4.ecom.checkout.steps.approve.termsAndConditions.accept();
                },
                get: function () {
                    jQuery.get( e4.settings.ecom.checkout.termsAndConditions, function ( data ) {
                        var jHtml = jQuery( data ).find( '.e-content-main' ).html();
                        jQuery( '.js-e-checkout-modal-terms-and-conditions' ).replaceWith( jHtml );
                    } );
                },
                accept: function () {
                    jQuery( '.js-e-accept-term-and-conditions' ).on( 'click', function () {
                        jQuery( 'input[name="EcomOrderCustomerAccepted"]' ).prop( 'checked', true );
                    } );
                }
            }
        },
        receipt: {
            init: function () {
                e4.util.hash.remove( 'step' );
            }
        },
    },
    tracking: {
        step: function ( data ) {
            var virtualPageview = {
                'event': 'VirtualPageview',
                'vpevent': 'VirtualPageview',
                'virtualPageURL': '/shop/cart/checkout?step=' + data.index + ' ' + data.name,
                'virtualPageTitle': 'Order Step ' + data.index + ' – ' + data.name
            };
            var checkout = {
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {
                            'step': data.index
                        }
                    }
                }
            };

            e4.gtm.pushDataLayer( virtualPageview );
            e4.gtm.pushDataLayer( checkout );
        },
        init: function () {}
    }
};

